
export default {
  'mapForm': {
    'placesAndDirections': 'Trouver et partir',
    'isochrones': 'Atteindre',
    'uploadedContentRendered': 'Contenu téléchargé rendu',
    'errorRenderingContentUploaded': 'Erreur lors du rendu du contenu téléchargé. Vérifiez le format et le contenu du fichier'
  }
}
